import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircle, faCircleExclamation, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { translate } from "../../core/i18n";
import { store } from "../../core/state";
import { needsSolutionAfterErrors } from "../SolutionArea";
import { EDITOR_VIEW_NAME, HELP_AREA_STATE, STEP_POPPER } from "../../core/constants";

import { Accordion } from "react-bootstrap";
import { SolutionAccordion } from "../accordions/SolutionAccordion";
import { useState } from "react";
import { getComponentData, setComponentData } from "../../core/views";

const getStepTask = (stepData)  => {    
  const step = stepData.currentStep;  
  if (!step) return null;
  const title = step.title ? `${step.title} <hr> ` : '';
  const stepContent = `${title}${step.content}`
  return stepContent
}

export const triggerShowHelp = (helpContent) => {
  const helpAreaState = getComponentData(HELP_AREA_STATE);
  const newHelpAreaState = { ...helpAreaState, show: true, hint: helpContent };
  setComponentData(HELP_AREA_STATE, newHelpAreaState);
}

const getSubTasks = (editorState) => {
  return editorState?.project?.subTasks?.map((subTask, index) => {
    const done = editorState?.data?.projectProgress !== undefined && editorState?.data?.projectProgress >= subTask.number;
    const exeError = editorState?.data?.errors?.length > 0;
    const exeErrorText = translate('view-editor-exe-error');
    const waiting = editorState?.data?.waitForSuccessEvent;
    const hasError = (exeError || editorState?.data?.projectError !== undefined) && !waiting ? true : false;
    const errorTask = hasError && (editorState?.data?.projectError === subTask.number);
    const errorText = exeError ? exeErrorText : subTask.error;
    const shownErrorMessage = errorTask ? errorText : '';

    let stateClass = 'is-pending';
    let stateIcon = faCircle;
    if (done) { stateClass = 'is-ok'; stateIcon = faCircleCheck; }
    else if (errorTask) { stateClass = 'is-error'; stateIcon = faCircleExclamation; }

    return (
      <div className={`task-req ${stateClass}`} key={index}>
        <span className="task-req-icon"><FontAwesomeIcon icon={stateIcon} /></span>
        <span className="task-req-text"><strong>{subTask.number}.</strong> <span dangerouslySetInnerHTML={{ __html: subTask.desc }}></span></span>
        {errorTask && <div className="task-req-error">{shownErrorMessage}</div>}
      </div>
    );
  });
}

export const TaskAreaCard = (props: { closeArea : () => void, taskOpened? : boolean }) => {
  const [stepPopper] = store.useState(STEP_POPPER);
  const [editorState] = store.useState(EDITOR_VIEW_NAME);
  const [helpAreaData] = store.useState(HELP_AREA_STATE);
  const [showHint, setShowHint] = useState(false);
  const [showPreviousTasks, setShowPreviousTasks] = useState(true);

  /*
  const requestHelpArea = () => {    
    const subTask = editorState?.project?.subTasks?.find(subTask => subTask.number === (editorState?.data?.projectProgress || 0) + 1);    
    if (subTask) {
      triggerShowHelp(subTask.help);
    }
  }

  const requestSolution = () => {
    triggerShowSolutionArea();
  }  */

  // Render only the first pending subtask as the current task
  const renderTaskLine = (task) => {
    if (!task) return null;
    const done = editorState?.data?.projectProgress !== undefined && (editorState?.data?.projectProgress >= task.number);
    const exeError = editorState?.data?.errors?.length > 0;
    const exeErrorText = translate('view-editor-exe-error');
    const waiting = editorState?.data?.waitForSuccessEvent;
    const hasError = (exeError || editorState?.data?.projectError !== undefined) && !waiting ? true : false;
    const errorTask = hasError && (editorState?.data?.projectError === task.number);
    const errorText = exeError ? exeErrorText : task.error;
    const shownErrorMessage = errorTask ? errorText : '';

    let stateClass = 'is-pending';
    let stateIcon = faCircle;
    if (done) { stateClass = 'is-ok'; stateIcon = faCircleCheck; }
    else if (errorTask) { stateClass = 'is-error'; stateIcon = faCircleExclamation; }

    return (
      <div className={`task-req ${stateClass}`} key={task.number}>
        <span className="task-req-icon"><FontAwesomeIcon icon={stateIcon} /></span>
        <span className="task-req-text"><strong>{task.number}.</strong> <span dangerouslySetInnerHTML={{ __html: task.desc }}></span></span>
        {errorTask && <div className="task-req-error">{shownErrorMessage}</div>}
      </div>
    );
  };

  const allSubTasks = editorState?.project?.subTasks || [];
  const progressNumber = editorState?.data?.projectProgress || 0;
  const currentOnlyTask = allSubTasks.find(t => t.number === progressNumber + 1);
  const subTaskContent = currentOnlyTask ? <div className="task-req-list">{renderTaskLine(currentOnlyTask)}</div> : null;
  
  const needsSolution = needsSolutionAfterErrors(editorState);
  //const hasSolution = solutionAreaShown(editorState) && needsSolution;

  //const closeButton = (editorState?.cfg?.editorFeatures?.openTaskOnDefault !== true && <CloseButton onClick={props.closeArea} /> );
  
  const stepTask = getStepTask(stepPopper);
  const hasTaskContent = editorState.project?.task || editorState.project?.subtasks || stepTask;
  const taskContent = stepTask || editorState?.project?.task;

  // compute help content first (used below)
  const subTask = editorState?.project?.subTasks?.find(subTask => subTask.number === (editorState?.data?.projectProgress || 0) + 1);
  let subTaskHelp = false;
  if (subTask && subTask.help) {
    subTaskHelp = true;
  }
  const helpContent = helpAreaData?.hint || subTask?.help || editorState?.project?.hint;
  const hasHelpContent = ( editorState.project?.hint || subTaskHelp);

  const currentTaskArea = (
    <>
      <div className="task-content" dangerouslySetInnerHTML={{ __html: taskContent }} />
      { subTaskContent }
      <div className="task-hint">
        <button className="hint-toggle" onClick={() => setShowHint(!showHint)}>
          {showHint ? 'Hilfe verstecken' : translate('view-editor-help-button')}
        </button>
        { showHint && (
          <div className="hint-content" dangerouslySetInnerHTML={{ __html: helpContent }} />
        )}
      </div>
    </>
  );


  // Build list of previously completed tasks
  const previousTasks = allSubTasks.filter(t => t.number <= progressNumber);
  const previousList = previousTasks.length > 0 ? (
    <div className="previous-list" style={{ display: showPreviousTasks ? 'block' : 'none' }}>
      {previousTasks.map(t => (
        <div className="previous-item" key={`prev-${t.number}`}>
          <span className="previous-item-icon">
            <FontAwesomeIcon icon={faCircleCheck} />
          </span>
          <span className="previous-item-text">
            <strong>{t.number}.</strong> <span dangerouslySetInnerHTML={{ __html: t.desc }}></span>
          </span>
        </div>
      ))}
    </div>
  ) : null;

  const solutionAccordion = <SolutionAccordion />
  const infoCard = (
    <div className="card card-design task-card">
      <div className="card-body">
        <div className="task-card-header" style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:'8px'}}>
          <div className="task-title">Aufgabe</div>
          {(editorState?.project?.subTasks?.length > 0) && (
            <span className={`task-status ${((editorState?.data?.projectProgress || 0) >= (editorState?.project?.subTasks?.length || 0)) ? 'completed' : 'in-progress'}`}>
              {((editorState?.data?.projectProgress || 0) >= (editorState?.project?.subTasks?.length || 0)) ? 'FERTIG' : 'IN ARBEIT'}
            </span>
          )}
        </div>
        { hasTaskContent && currentTaskArea }
        { hasHelpContent && false /* button toggles hint above */ }
        { solutionAccordion }
        {previousTasks.length > 0 && (
          <div className="previous-section">
            <button 
              className="previous-title-toggle" 
              onClick={() => setShowPreviousTasks(!showPreviousTasks)}
            >
              <span className="previous-title">Vorherige Aufgaben</span>
              <FontAwesomeIcon 
                icon={showPreviousTasks ? faChevronUp : faChevronDown} 
                className="previous-toggle-icon"
              />
            </button>
            { previousList }
          </div>
        )}
      </div>
    </div>
  );
  return infoCard;

}